import React from 'react';
import { Box, InputBase, Typography } from '@mui/material';
import LoadingOverlayButton from '../../component/button/loading-overlay-button.component';
import i18n from '../../i18n';
import { ReactComponent as AutoStoriesIcon } from '../../static/images/svg/auto_stories.svg';
import { MenuStoreCommonDialog } from './menu-store-common-dialog.component';

type MenuStoreActivateDialogProps = {
    /** 弹窗开关。 */
    open: boolean;
    /** 菜单名称。 */
    menuName: string;
    /** 菜单图片样式变量。 */
    menuImageStyle: React.CSSProperties;
    /** 激活码输入值。 */
    activateLicense: string;
    /** 激活码输入变化。 */
    onActivateLicenseChange: (value: string) => void;
    /** 关闭弹窗。 */
    onClose: () => void;
    /** 提交激活。 */
    onSubmit: () => void;
    /** 提交中状态。 */
    submitting: boolean;
};

/**
 * 菜单激活弹窗。
 */
export function MenuStoreActivateDialog(props: MenuStoreActivateDialogProps): React.ReactElement | null {
    /** 组件属性。 */
    const { open, menuName, menuImageStyle, activateLicense, onActivateLicenseChange, onClose, onSubmit, submitting } = props;
    if (!open) {
        return null;
    }
    return (
        <MenuStoreCommonDialog
            title={i18n.t('menu_store_activate_title')}
            onClose={onClose}
            dialogClassName="menu-store-activate-dialog--activate"
            hideTitleIcon
            titlePrefix={<AutoStoriesIcon className="menu-store-activate-dialog__book-icon" aria-hidden />}
            hideBottomClose
            footer={(
                <Box className="menu-store-activate-dialog__footer">
                    <LoadingOverlayButton
                        className="menu-store-activate-dialog__submit menu-store-activate-dialog__submit--activate"
                        variant="contained"
                        disableElevation
                        fullWidth
                        loading={submitting}
                        loadingIndicatorSize={22}
                        onClick={onSubmit}
                    >
                        {i18n.t('menu_store_activate_submit')}
                    </LoadingOverlayButton>
                </Box>
            )}
        >
            <Box className="menu-store-activate-dialog__thumb" aria-hidden style={menuImageStyle} />
            <Box className="menu-store-activate-dialog__fields">
                <Box className="menu-store-activate-dialog__readonly-row">
                    <Typography variant="body1" component="span" className="menu-store-activate-dialog__field-label">
                        {i18n.t('menu_store_activate_menu_name_label')}
                    </Typography>
                    <Typography variant="subtitle1" component="span" className="menu-store-activate-dialog__field-value">
                        {menuName}
                    </Typography>
                </Box>
                <Box className="menu-store-activate-dialog__license-row">
                    <Typography variant="body1" component="span" className="menu-store-activate-dialog__field-label">
                        {i18n.t('menu_store_activate_license_label')}
                    </Typography>
                    <InputBase
                        className="menu-store-activate-dialog__license-input"
                        value={activateLicense}
                        onChange={(e) => onActivateLicenseChange(e.target.value)}
                        disabled={submitting}
                        inputProps={{
                            'aria-label': i18n.t('menu_store_activate_license_label'),
                            className: 'menu-store-activate-dialog__license-input-native',
                        }}
                    />
                </Box>
            </Box>
        </MenuStoreCommonDialog>
    );
}
